<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <form @submit.prevent="onSubmit">
        <v-card-title>
          <span class="headline">{{ mess.dialog_add_company_title }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row v-if="!isInternationalByLang">
              <v-col cols="auto">
                <toggle-buttons
                  :buttons="toggleButtons"
                  :active="form.requisites_country"
                  v-model="form.requisites_country"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" class="pb-0">
                <v-text-field
                  v-model="form.holding"
                  outlined
                  dense
                  :label="mess.dialog_add_company_name_main"
                />
              </v-col>

              <v-col cols="6" class="pb-0">
                <v-text-field
                  v-model="form.name"
                  v-validate="required['name']"
                  outlined
                  dense
                  :label="mess.dialog_add_company_name"
                  :error-messages="errors.collect('name')"
                  data-vv-name="name"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="form.sales_area"
                  v-validate="required['sales_area']"
                  :items="salesAreaDataSorted"
                  outlined
                  dense
                  :label="mess.dialog_add_company_sales_area"
                  :error-messages="errors.collect('sales_area')"
                  data-vv-name="sales_area"
                />
              </v-col>

              <v-col cols="6" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="form.industry"
                  v-validate="required['industry']"
                  :items="industryDataSorted"
                  outlined
                  dense
                  :label="mess.dialog_add_company_industry"
                  :error-messages="errors.collect('industry')"
                  data-vv-name="industry"
                />
              </v-col>
            </v-row>

            <v-row v-if="form.requisites_country === 'russia'">
              <v-col cols="6" class="pb-0 pt-0">
                <v-text-field
                  v-model="form.inn"
                  v-validate="innRequired"
                  outlined
                  dense
                  :label="mess.dialog_add_company_inn"
                  :error-messages="errors.collect('inn')"
                  data-vv-name="inn"
                />
              </v-col>

              <v-col cols="6" class="pb-0 pt-0">
                <v-text-field
                  v-model="form.kpp"
                  outlined
                  dense
                  :label="mess.dialog_add_company_kpp"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col class="pt-0">
                <b>{{ mess.dialog_add_company_contacts }}</b>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" class="pb-0 pt-0">
                <v-text-field
                  v-model="form.phone"
                  v-validate="
                    required['phone'] && !form.email ? 'required' : ''
                  "
                  outlined
                  dense
                  :label="mess.dialog_add_company_phone"
                  :error-messages="errors.collect('phone')"
                  data-vv-name="phone"
                />
              </v-col>

              <v-col cols="6" class="pb-0 pt-0">
                <v-text-field
                  v-model="form.email"
                  v-validate="
                    required['email'] && !form.phone ? 'required' : ''
                  "
                  outlined
                  dense
                  :label="mess.dialog_add_company_email"
                  :error-messages="errors.collect('email')"
                  data-vv-name="email"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" class="pb-0 pt-0">
                <v-text-field
                  v-model="form.website"
                  outlined
                  dense
                  :label="mess.dialog_add_company_website"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" class="pb-0 pt-0">
                <v-text-field
                  v-model="form.address"
                  outlined
                  dense
                  :label="mess.dialog_add_company_address"
                />
              </v-col>

              <v-col cols="auto" class="pb-0 pt-0">
                <v-btn
                  @click="companyOnMapDialog = true"
                  color="primary"
                  depressed
                >
                  {{ mess.dialog_base_button_show_on_map }}
                  <v-icon right>mdi-map-legend</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="pt-0">
                <b>{{ mess.dialog_add_company_bank_details }}</b>
              </v-col>
            </v-row>

            <v-row>
              <v-col
                v-if="form.requisites_country === 'another_country'"
                cols="12"
                class="pb-0 pt-0"
              >
                <v-text-field
                  v-model="form.bank_name"
                  outlined
                  dense
                  :label="mess.dialog_add_company_bank_name"
                />
              </v-col>

              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="form.bank_account"
                  outlined
                  dense
                  :label="mess.dialog_add_company_bank_account"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="form.bank_id"
                  v-validate="'required'"
                  outlined
                  dense
                  :label="mess.dialog_add_company_bank_id"
                  :error-messages="errors.collect('bank_id')"
                  data-vv-name="bank_id"
                />
              </v-col>
            </v-row>

            <v-row v-if="form.requisites_country === 'another_country'">
              <v-col cols="6" class="pb-0 pt-0">
                <v-text-field
                  v-model="form.bank_swift"
                  outlined
                  dense
                  :label="mess.dialog_add_company_bank_swift"
                />
              </v-col>

              <v-col cols="6" class="pb-0 pt-0">
                <v-text-field
                  v-model="form.bank_code"
                  outlined
                  dense
                  :label="mess.dialog_add_company_bank_code"
                />
              </v-col>
            </v-row>

            <v-row v-if="form.requisites_country === 'another_country'">
              <v-col cols="6" class="pb-0 pt-0">
                <v-text-field
                  v-model="form.bank_country"
                  outlined
                  dense
                  :label="mess.dialog_add_company_bank_country"
                />
              </v-col>

              <v-col cols="6" class="pb-0 pt-0">
                <v-text-field
                  v-model="form.bank_city"
                  outlined
                  dense
                  :label="mess.dialog_add_company_bank_city"
                />
              </v-col>
            </v-row>

            <v-row v-if="form.requisites_country === 'another_country'">
              <v-col cols="6" class="pb-0 pt-0">
                <v-text-field
                  v-model="form.bank_address"
                  outlined
                  dense
                  :label="mess.dialog_add_company_bank_address"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col class="pt-0">
                <b>{{ mess.dialog_add_company_currency }}</b>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="auto" class="pt-0 pb-0">
                <toggle-buttons
                  :buttons="currencyButtons"
                  :active="form.currency"
                  v-model="form.currency"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions style="padding: 0 24px 16px">
          <v-spacer />

          <v-btn
            color="primary"
            depressed
            dark
            @click="dialog = false"
          >
            {{ mess.dialog_base_button_close }}
          </v-btn>

          <v-btn
            :loading="loading"
            color="primary"
            depressed
            dark
            type="submit"
          >
            {{ mess.dialog_base_button_send }}
          </v-btn>
        </v-card-actions>

        <v-btn
          absolute
          top
          right
          text
          icon
          @click="dialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </form>

      <company-on-map-dialog
        :is-visible.sync="companyOnMapDialog"
        @set-address="
          data => {
            form.address = data.address;
            form.coords = data.coords;
          }
        "
      />
    </v-card>
  </v-dialog>
</template>

<script>
// Libs
import axios from "axios";
import sortBy from "lodash/sortBy";

// Components
import ToggleButtons from "@/components/ToggleButtons";
import CompanyOnMapDialog from "@/components/dialogs/CompanyOnMapDialog";

// Models
import notifications from "@/models/notificationTemplates";

export default {
  $_veeValidate: {
    validator: "new"
  },
  name: "AddCompanyDialog",
  components: { CompanyOnMapDialog, ToggleButtons },
  props: {
    isEmc: {
      type: Boolean,
      default: false
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    salesAreaData: {
      type: Array,
      default: () => []
    },
    industryData: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    dialog: false,
    loading: false,
    companyOnMapDialog: false,
    dictionary: {
      custom: {
        name: {
          required: () => "Обязательное поле"
        },
        sales_area: {
          required: () => "Обязательное поле"
        },
        industry: {
          required: () => "Обязательное поле"
        },
        inn: {
          required: () => "Обязательное поле"
        },
        phone: {
          required: () => "Обязательное поле"
        },
        email: {
          required: () => "Обязательное поле"
        },
        bank_id: {
          required: () => "Обязательное поле"
        }
      }
    },
    currency: [
      {
        name: "CNY",
        type: "CNY",
        icon: "mdi-currency-cny"
      },
      {
        name: "RUB",
        type: "RUB",
        icon: "mdi-currency-rub"
      },
      {
        name: "EUR",
        type: "EUR",
        icon: "mdi-currency-eur"
      },
      {
        name: "USD",
        type: "USD",
        icon: "mdi-currency-usd"
      }
    ],
    form: {
      requisites_country: "russia",
      holding: undefined,
      name: undefined,
      sales_area: undefined,
      industry: undefined,
      inn: undefined,
      kpp: undefined,
      phone: undefined,
      email: undefined,
      website: undefined,
      address: undefined,
      coords: undefined,
      bank_name: undefined,
      bank_account: undefined,
      bank_id: undefined,
      bank_swift: undefined,
      bank_code: undefined,
      bank_country: undefined,
      bank_city: undefined,
      bank_address: undefined,
      currency: "RUB"
    }
  }),
  methods: {
    onSubmit() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;

          let formData = new FormData();
          for (let key in this.form) {
            formData.append(key, this.form[key]);
          }

          axios
            .post("/local/ajax/addNewMyCustomer.php", formData)
            .then(response => {
              if (response.data.success) {
                this.$emit("add-company", notifications.success.newCompanySend);
                this.dialog = false;
                this.resetForm();
              } else {
                this.$emit("add-company", notifications.error.base);
              }
            })
            .catch(err => {
              this.$emit("add-company", notifications.error.base);
              throw err;
            })
            .finally(() => (this.loading = false));
        }
      });
    },
    resetForm() {
      for (let key in this.form) {
        this.form[key] = undefined;
      }
      this.form.requisites_country = "russia";
      this.form.currency = "RUB";
    }
  },
  computed: {
    isInternationalByLang() {
      return this.$_locale !== "ru-RU";
    },
    currencyButtons() {
      return this.currency;
    },
    salesAreaDataSorted() {
      return sortBy(this.salesAreaData, ["text"]);
    },
    industryDataSorted() {
      return sortBy(this.industryData, ["text"]);
    },
    required() {
      if (this.form.requisites_country === "russia")
        return {
          name: "required",
          sales_area: "required",
          industry: "required",
          inn: "required",
          phone: "required",
          email: "required"
        };
      if (this.form.requisites_country === "another_country")
        return {
          name: "required",
          sales_area: "required",
          industry: "required",
          inn: "required",
          phone: "required",
          email: "required"
        };
      return [];
    },
    innRequired() {
      return this.form.requisites_country === "russia"
        ? this.required["inn"]
        : "";
    },
    toggleButtons() {
      return [
        {
          name: this.mess.dialog_add_company_toggle_button_russia,
          type: "russia"
        },
        {
          name: this.mess.dialog_add_company_toggle_button_another_country,
          type: "another_country"
        }
      ];
    }
  },
  watch: {
    isVisible(val) {
      this.dialog = val;
    },
    dialog(val) {
      this.$emit("update:is-visible", val);
      this.$validator.reset();
    },
    isInternationalByLang: {
      handler(val) {
        if (val) {
          this.form.requisites_country = "another_country";
          this.form.currency = "EUR";
        }
      },
      immediate: true
    },
    "form.requisites_country"() {
      this.$validator.reset();
    }
  },
  mounted() {
    this.$validator.localize("ru", this.dictionary);
  }
};
</script>

<style lang="scss"></style>
